import React from "react";

export const Footer = () => {
        return (
                <div id="footer">
                        <p className="footer-text">© 2025 Eric Taylor. Not Investment Advice. Made in Brooklyn, NY. (Beta)</p>
                </div>
        );
};

